/* Portal Re-Usable Slidepane  */

(function (jQuery, undefined) {
    var sm = window.sm = window.sm || {};
    var windowProxy;
    var actionQueue = [];

    if (typeof sm.portal === "undefined") {
        jQuery.extend(sm, { portal: {} });
    }
    if (typeof sm.portal.ui === "undefined") {
        jQuery.extend(sm.portal, { ui: {} });
    }
    if (typeof sm.portal.ui.slidepane === "undefined") {
        jQuery.extend(sm.portal.ui, { slidepane: {} });
    }

    function initSlidepane() {
        unobtrusiveSlidepaneWiring();
    }

    function unobtrusiveSlidepaneWiring() {
        sm.portal.ui.slidepane.stickySlideup();
        sm.portal.ui.slidepane.slidepaneResize();
    }

    /* SLIDEUP FUNCTION */
    function stickySlideup() {
        // wire button
        jQuery('[data-activate-slideup]').not('[data-processed="true"]').each(function () {
            var that = jQuery(this);
            var $mySlideup = jQuery('#' + that.attr('data-activate-slideup'));


            var opencb = that.is('[data-after-slide-up]') ? that.attr('data-after-slide-up') : null;
            var openargs = that.is('[data-after-slide-up-args]') ? that.attr('data-after-slide-up-args') : null;
            var closecb = that.is('[data-after-slide-down]') ?  that.attr('data-after-slide-down') : null;
            var closeargs = that.is('[data-after-slide-down-args]') ? that.attr('data-after-slide-down-args') : null;

            that.on('click', function () {
                if (!that.hasClass('active')) {
                    sm.portal.ui.slidepane.openStickySlideup($mySlideup, opencb, openargs);                    
                }
                else {
                    sm.portal.ui.slidepane.closeThisSlideup($mySlideup, closecb, closeargs);
                }
            })
            that.attr('data-processed', true);
        });

        // wire close
        jQuery('[data-close-slideup]').not('[data-processed="true"]').each(function () {
            var that = jQuery(this);
            var mySlideup = jQuery('#' + that.attr('data-close-slideup'));
             
            that.on('click', function () {
                sm.portal.ui.slidepane.closeThisSlideup(mySlideup);
            });
            that.attr('data-processed', true);
        });
    }

    function openStickySlideup(slideup, cb, args) {
        if (!sm.portal.utility.isNullOrEmpty(slideup)) {
            var relatedButton = jQuery('[data-activate-slideup="' + slideup.attr('id') + '"]');
            var transitionEnded = sm.portal.utility.whichTransitionEvent();

            // activate related button (if applicable)
            if (!sm.portal.utility.isNullOrEmpty(relatedButton) && !relatedButton.hasClass('active')) {
                relatedButton.addClass('active');
            }

            // close other slideups
            sm.portal.ui.slidepane.closeAllSlideups();

            // make it visible
            slideup.removeClass('hidden').addClass('visible');

            // position slideup
            sm.portal.ui.slidepane.fixStickySlideupPosition();

            // grow height per css
            slideup.addClass('inYourFace');

            // disable all slideup control buttons until animation is done - otherwise could end up in a weird state
            jQuery('[data-activate-slideup]').not('[disabled]').attr('disabled', 'disabled').attr('data-temp-disabled', true);

            var transitionEndFired = false;
            slideup.one(transitionEnded, function () {
                transitionEndFired = openSlideupInternal(transitionEndFired, cb, args);
                //console.log('Backside event fired');    // Great debugging flag
            });

            setTimeout(function () {
                transitionEndFired = openSlideupInternal(transitionEndFired, cb, args);
                //console.log('Backside timeout fired');    // Great debugging flag
                jQuery(slideup).modalTabbing();
            }, 300);
        }
    }

    function closeThisSlideup(slideup, cb, args) {

        var transitionEnded = sm.portal.utility.whichTransitionEvent();
        var originalPosition = jQuery('[data-original-position]').attr('data-original-position');

        // if we don't have a valid slideup ID passed in, logically hide the only showing one
        if (typeof slideup[0] == "undefined") {
            slideup = jQuery('#' + jQuery('.smStickySlideup.inYourFace.visible').attr('id'));
        }

        // Deactivate related button
        var relatedButton = jQuery('[data-activate-slideup="' + slideup.attr('id') + '"]');
        if (!sm.portal.utility.isNullOrEmpty(relatedButton)) {
            relatedButton.removeClass('active');
        }

        // disable all slideup control buttons until animation is done - otherwise could end up in a weird state
        jQuery('[data-activate-slideup]').not('[disabled]').attr('disabled', 'disabled').attr('data-temp-disabled', true);
        slideup.removeClass('inYourFace');

        // Transition End handlers
        var transitionEndFired = false;
        slideup.one(transitionEnded, function () {
            transitionEndFired = closeSlideupInternal(slideup, transitionEndFired, originalPosition);
            //console.log('Backside event fired');    // Great debugging flag
        });

        // Edge versions aren't always firing the TransitionEnd event properly, so this is to catch those situations.
        setTimeout(function () {
            transitionEndFired = closeSlideupInternal(slideup, transitionEndFired, originalPosition);
            //console.log('Backside timeout fired');    // Great debugging flag
            if (!sm.portal.utility.isNullOrEmpty(relatedButton) && !relatedButton.hasClass('active')) {
                relatedButton.focus();
            }
        }, 300);
    }

    function closeAllSlideups(cb, args) {
        var visibleSlideups = jQuery('.smStickySlideup.visible.inYourFace');
        var transitionEnded = sm.portal.utility.whichTransitionEvent();

        visibleSlideups.each(function () {
            var that = jQuery(this);
            var relatedButton = jQuery('[data-activate-slideup="' + that.attr('id') + '"]');
            if (!sm.portal.utility.isNullOrEmpty(relatedButton)) {
                relatedButton.removeClass('active');
            }

            // disable all slideup control buttons until animation is done - otherwise could end up in a weird state
            jQuery('[data-activate-slideup]').not('[disabled]').attr('disabled', 'disabled').attr('data-temp-disabled', true);

            that.removeClass('inYourFace');

            var transitionEndFired = false;

            that.one(transitionEnded, function () {
                transitionEndFired = closeSlideupInternal(that, transitionEndFired, null, cb, args); 23
                //console.log('Backside Event fired');    // Great debugging flag
            });

            // Edge versions aren't always firing the TransitionEnd event properly, so this is to catch those situations.
            setTimeout(function () {
                transitionEndFired = closeSlideupInternal(that, transitionEndFired, null, cb, args);
                //console.log('Backside timeout fired');    // Great debugging flag
            }, 300);
        });
    }

    // Handles the opening action of sticky footer slideup for Edge event-firing issues
    function openSlideupInternal(transitionEndFired, cb, args) {
        if (!transitionEndFired) {

            transitionEndFired = true;

            sm.portal.theme.freezeContent();
            sm.portal.ui.slidepane.slideupContentHeights();

            // re-enable buttons
            jQuery('[data-activate-slideup][data-temp-disabled]').removeAttr('disabled').removeAttr('data-temp-disabled');

            // handle callback
            sm.portal.ui.executeFunctionByName(cb, window, args);
        }
        return transitionEndFired;
    }

    // Handles the closing action of sticky footer slideup for Edge event-firing issues
    function closeSlideupInternal(slideup, transitionEndFired, originalPosition, cb, args) {

        if (!transitionEndFired) {

            transitionEndFired = true;

            // after it lowers - make it invisible again
            slideup.removeClass('visible').addClass('hidden');

            // re-enable buttons
            jQuery('[data-activate-slideup][data-temp-disabled]').removeAttr('disabled').removeAttr('data-temp-disabled');

            // Toggle this one
            sm.portal.theme.unfreezeContent(originalPosition);

            // remove data-original-position
            jQuery('body').removeAttr('data-original-position');

            // process callbacks if present
            if (!sm.portal.utility.isNullOrEmpty(cb) && typeof cb === 'function') {
                eval(cb(args));
            }            
        }
        return transitionEndFired;
    }

    // Manages Positioning of Sticky Footer When Responsive
    function fixStickySlideupPosition() {
        var footerButtonsHeight = jQuery('.smStickyFooterButtons').outerHeight(true);
        jQuery('.smStickySlideup').css('bottom', footerButtonsHeight + 'px');
    }

    // Adds height to course lists (looks for areas marked data-to-bottom) - for scrolling content
    function slideupContentHeights() {
        var activeSlideup = jQuery('.smStickySlideup.inYourFace');
        var totalHeight = jQuery(window).innerHeight();
        var headerToExclude = activeSlideup.find('.smSlideupHeader');
        var whichScenario = activeSlideup.children('div:visible').attr('class');
        var sliderContentHeight = activeSlideup.find('[data-to-bottom]'); /* USE THIS ATTRIBUTE TO SPECIFY WHAT AREA SHOULD BE SCROLLABLE */
        var exclusionHeight;
        // accommodate various cart scenarios

        switch (whichScenario) {
            case 'smCoursesCart':
                var checkoutFooterToExclude = activeSlideup.find('.cartCheckout').outerHeight(true);// includes margins
                exclusionHeight = headerToExclude.outerHeight(true) + jQuery('.smStickyFooterButtons').outerHeight(true) + checkoutFooterToExclude + 10;
                break;

            case 'smLoginRegister':
                exclusionHeight = headerToExclude.outerHeight(true) + jQuery('.smStickyFooterButtons').outerHeight(true) + 60;
                break;

            case 'smPaymentForm':
                exclusionHeight = headerToExclude.outerHeight(true) + jQuery('.smStickyFooterButtons').outerHeight(true) + 65;
                break;

            case 'smProcessingConfirmation':
                exclusionHeight = headerToExclude.outerHeight(true) + jQuery('.smStickyFooterButtons').outerHeight(true) + 65;
        }

        // cart items height
        sliderContentHeight.height(totalHeight - exclusionHeight + 'px');
    }

    function slidepaneResize() {
        jQuery(window).onDelayed('resize', 100, function () {
            sm.portal.ui.slidepane.fixStickySlideupPosition();
            sm.portal.ui.slidepane.slideupContentHeights();
        });
    }


    jQuery.extend(true, sm.portal.ui.slidepane, {
        initSlidepane: initSlidepane,
        stickySlideup: stickySlideup,
        openStickySlideup: openStickySlideup,
        closeThisSlideup: closeThisSlideup,
        closeAllSlideups: closeAllSlideups,
        fixStickySlideupPosition: fixStickySlideupPosition,
        slidepaneResize: slidepaneResize,
        slideupContentHeights: slideupContentHeights
    });

})(jQuery);

(function (window, undefined) {

    jQuery(document).bind('afterSMInitPage', function () {
        sm.portal.ui.slidepane.initSlidepane();
    });

})(window);

